import Team9 from './Team9'
export default Team9
